(() => {
  const escape = (value) =>
    String(value ?? '').replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c],
    );
  const safeUrl = (value) => {
    try {
      const u = new URL(value, location.origin);
      return ['https:', 'http:'].includes(u.protocol) ? u.href : '';
    } catch {
      return '';
    }
  };
  if (!customElements.get('sf-product-compare'))
    customElements.define(
      'sf-product-compare',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const opts = { signal: this.controller.signal };
          this.key =
            'phone-shop-compare:' + document.documentElement.lang + ':' + (window.Shopify?.currency?.active || '');
          this.items = [];
          try {
            const saved = JSON.parse(sessionStorage.getItem(this.key) || '[]');
            if (Array.isArray(saved))
              this.items = saved
                .filter((p) => p && typeof p.id === 'string' && typeof p.title === 'string' && safeUrl(p.url))
                .slice(0, 3);
          } catch {}
          this.tray = this.querySelector('.live-compare-tray');
          this.dialog = this.querySelector('dialog');
          document.addEventListener(
            'click',
            (e) => {
              const b = e.target.closest('[data-sf-compare]');
              if (b) {
                try {
                  this.toggle(JSON.parse(b.dataset.sfCompare));
                } catch {
                  this.render(this.dataset.empty);
                }
                return;
              }
              const action = e.target.closest('[data-sf-compare-action]');
              if (!action || !this.contains(action)) return;
              switch (action.dataset.sfCompareAction) {
                case 'open':
                  this.open();
                  break;
                case 'close':
                  this.dialog.close();
                  break;
                case 'clear':
                  this.items = [];
                  this.save();
                  this.render();
                  this.sync();
                  break;
                case 'remove':
                  this.items = this.items.filter((p) => p.id !== action.dataset.id);
                  this.save();
                  this.render();
                  this.sync();
                  if (this.items.length < 2) this.dialog.close();
                  else {
                    this.renderTable();
                    this.dialog.querySelector('[data-sf-compare-action=close]')?.focus();
                  }
                  break;
              }
            },
            opts,
          );
          this.dialog.addEventListener(
            'click',
            (e) => {
              if (e.target === this.dialog) {
                const r = this.dialog.getBoundingClientRect();
                if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
                  this.dialog.close();
              }
            },
            opts,
          );
          document.addEventListener('shopify:section:load', () => this.sync(), opts);
          document.addEventListener('sf:products:updated', () => this.sync(), opts);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.sync());
          }
          this.render();
          this.sync();
        }
        save() {
          try {
            sessionStorage.setItem(this.key, JSON.stringify(this.items));
          } catch {}
        }
        toggle(p) {
          const index = this.items.findIndex((x) => x.id === p.id);
          let message = '';
          if (index >= 0) this.items.splice(index, 1);
          else if (this.items.length >= 3) message = this.dataset.limit;
          else if (this.items.length && this.items[0].group !== p.group) message = this.dataset.group;
          else this.items.push(p);
          this.save();
          this.render(message);
          this.sync();
        }
        sync() {
          document.querySelectorAll('[data-sf-compare]').forEach((b) => {
            try {
              const p = JSON.parse(b.dataset.sfCompare),
                selected = this.items.some((x) => x.id === p.id),
                label = selected ? this.dataset.selected : this.dataset.label;
              if (b.getAttribute('aria-pressed') !== String(selected)) b.setAttribute('aria-pressed', String(selected));
              const text = b.querySelector('[data-sf-compare-label]');
              if (text && text.textContent !== label) text.textContent = label;
              const icon = b.querySelector('[aria-hidden]');
              if (icon) icon.textContent = selected ? '✓' : '+';
            } catch {}
          });
        }
        photo(p) {
          return p.image && safeUrl(p.image)
            ? `<img src="${escape(safeUrl(p.image))}" alt="${escape(p.title)}" width="500" height="500" loading="lazy">`
            : '';
        }
        render(message = '') {
          this.tray.hidden = !this.items.length && !message;
          this.tray.innerHTML = `<div class="live-compare-previews">${this.items.map((p) => this.photo(p)).join('')}<span>${this.items.length} / 3</span></div><span class="live-compare-notice" role="status">${escape(message || (this.items.length === 1 ? this.dataset.empty : ''))}</span><button class="sf-button" data-sf-compare-action="open" type="button" ${this.items.length < 2 ? 'disabled' : ''}>${escape(this.dataset.label)} (${this.items.length})</button><button class="sf-icon-button" type="button" data-sf-compare-action="clear" aria-label="${escape(this.dataset.clear)}">×</button>`;
        }
        renderTable() {
          const rows = [
            [this.dataset.price, (p) => (p.priceLabel ? p.priceLabel + ' ' : '') + p.price],
            [this.dataset.brand, (p) => p.brand],
            [this.dataset.stock, (p) => p.availability],
          ];
          const options = new Set(
            this.items.flatMap((p) => (p.options || []).filter((o) => o.name !== 'Title').map((o) => o.name)),
          );
          options.forEach((name) =>
            rows.push([
              name,
              (p) =>
                (p.options || [])
                  .find((o) => o.name === name)
                  ?.values?.map((v) => (typeof v === 'object' ? v.name : v))
                  .join(', ') || '—',
            ]),
          );
          const keys = new Set(
            this.items.flatMap((p) =>
              p.details && typeof p.details === 'object' && !Array.isArray(p.details) ? Object.keys(p.details) : [],
            ),
          );
          keys.forEach((key) => rows.push([key, (p) => p.details?.[key] ?? '—']));
          this.dialog.innerHTML = `<div class="live-compare-head"><div><span class="live-kicker">${escape(this.dataset.kicker)}</span><h2 id="SfCompareTitle">${escape(this.dataset.title)}</h2></div><button class="sf-icon-button" type="button" data-sf-compare-action="close" aria-label="${escape(this.dataset.close)}" autofocus>×</button></div><div class="live-compare-table-wrap"><table class="live-compare-table" style="--compare-columns:${this.items.length}"><thead><tr><th scope="col"></th>${this.items.map((p) => `<th scope="col">${this.photo(p)}<strong>${escape(p.title)}</strong><small>${escape(p.brand)}</small><button class="sf-text-link" type="button" data-sf-compare-action="remove" data-id="${escape(p.id)}">${escape(this.dataset.remove)}</button></th>`).join('')}</tr></thead><tbody>${rows.map(([label, read]) => `<tr><th scope="row">${escape(label)}</th>${this.items.map((p) => `<td>${escape(read(p))}</td>`).join('')}</tr>`).join('')}<tr><th scope="row"></th>${this.items.map((p) => `<td><a class="sf-button" href="${escape(safeUrl(p.url))}">${escape(this.dataset.view)}</a></td>`).join('')}</tr></tbody></table></div>`;
        }
        open() {
          if (this.items.length < 2) return;
          this.renderTable();
          this.dialog.showModal();
        }
        disconnectedCallback() {
          this.controller?.abort();
          this.unsubscribeCart?.();
        }
      },
    );
})();
